import { IComponentOptions, IController, IFormController } from 'angular';
import { PasswordService } from '../../../core/services/password/password.service';
import { ToastrService } from '../../../core/services/toastr/toastr.service';
import { PASSWORD_REGEXP } from '../../../helpers/validators';
import './change-password.component.scss';

class ChangePasswordController implements IController {
  static $inject = [
    'PasswordService',
    'ToastrService'
  ];
  currentPassword: string;
  newPassword: string;
  form: IFormController;
  passwordPattern = PASSWORD_REGEXP;
  loading = false;

  constructor( private passwordService: PasswordService,
               private toastrService: ToastrService ) {
  }

  submit() {
    if ( this.form.$invalid ) {
      return;
    }
    this.loading = true;
    this.passwordService.changePassword(this.currentPassword, this.newPassword)
      .then(( res ) => {
        this.toastrService.success(res.text || 'Password changed');
        this.currentPassword = '';
        this.newPassword = '';
      })
      .catch(( err ) => {
        console.log(err);
        if ( err.data && err.data.text ) {
          return this.toastrService.error(err.data.text);
        }
        this.toastrService.error('Error');
      })
      .finally(() => this.loading = false);
  }
}

export const ChangePasswordComponent: IComponentOptions = {
  controller: ChangePasswordController,
  template: require('./change-password.component.html')
};



// WEBPACK FOOTER //
// ./app/shared/components/change-password/change-password.component.ts